import React, { useState, memo } from "react";
import "./MarketSummary.css";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import Clear from "@mui/icons-material/Clear";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import ArrowCircleDown from "@mui/icons-material/ArrowCircleDown";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import { Config } from "../../../Utils/Config";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import StoreIcon from '@mui/icons-material/Store';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';




let summary = [];




const MarketSummary = memo((props) => {
 
  // const profileData = props.profileData.profileDtls;
  const profileData = props.profileData.profileInfo;
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);




  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open_Popover = Boolean(anchorEl);

  const toggle = () => {
    props.toggleBtnClose(!open);
    setOpen(!open);
  };

  //get parks summary details
  const getSummaryDetails = () => {
    summary = [];
    var userDetails = localStorage.getItem('user') !== null ? localStorage.getItem('user') : null;
    var userType = userDetails !== null && JSON.parse(userDetails).usertype !== null ? JSON.parse(userDetails).usertype : "";
    let summaryDetails = props.summaryData.summaryInfo;
    const ignoredKeys = [
      "rvparkids",
      "marketdemandformarket",
      "marketdemandfornational",
      "demandsupplyratioformarket",
      "demandsupplyratiofornational",
      "rvparkdemandscoreformarket",
      "rvparkdemandscorefornational",
      "caucasian",
      "black",
      "hispanic",
      "others",
      "avgmaleinmarket",
      "avgfemaleinmarket",
      "asianpacific",
      "potentialcampers",
      "percentageofhousehold",
      "avgfuelcost"
    ];
    const FreeUser = userType === "Free";

  
    for (let i = 0; i < Object.keys(summaryDetails).length; i++) {
      const key = Object.keys(summaryDetails)[i]?.toLowerCase();
      const value = Object.values(summaryDetails)[i];
      if (
        (FreeUser && !ignoredKeys.includes(key)) || (
          value !== null &&
          value !== undefined &&
          value !== "" &&
          value !== 0 &&
          value !== 'N/A' &&
          !ignoredKeys.includes(key)
        )
      ) {
        let tableHeader =
          Object.keys(summaryDetails)[i] === "rvparksinmarket"
            ? "RV Parks in market"
            : Object.keys(summaryDetails)[i] === "totalrvparksites"
              ? "Total Camping spots"
              : Object.keys(summaryDetails)[i] === "avgpricepernight"
                ? "Average price per night"
                : Object.keys(summaryDetails)[i] === "countofhousehold"
                  ? "Households"
                  : Object.keys(summaryDetails)[i] === "marketscore"
                    ? "Market Score"
                    : Object.keys(summaryDetails)[i] === "demandscore"
                      ? "Demand Score"
                      : Object.keys(summaryDetails)[i] === "avgsizeofpark"
                          ? "Average Size Of Park"
                          : Object.keys(summaryDetails)[i] === "rvownershipinmarket"
                            ? "RV Ownership in market"
                            : Object.keys(summaryDetails)[i] === "population"
                                ? "Population"
                                : Object.keys(summaryDetails)[i] === "populationdensity"
                                ? "Population Density(per sq mi)"
                                : Object.keys(summaryDetails)[i] === "regiontype"
                                ? "Region Type"
                                : Object.keys(summaryDetails)[i] === "incomepercapita"
                                  ? "Income per capita"
                                    : Object.keys(summaryDetails)[i] === "avgage"
                                      ? "Average Age"
                                      : Object.keys(summaryDetails)[i] === "fivetotwentyfour"
                                        ? "Population age from 5-24"
                                        : Object.keys(summaryDetails)[i] === "twentyfivetofortyfour"
                                          ? "Population age from 25-44"
                                          : Object.keys(summaryDetails)[i] === "fortyfivetofiftyfour"
                                            ? "Population age from 45-54"
                                            : Object.keys(summaryDetails)[i] === "fiftyfivetoseventyfour"
                                              ? "Population age from 55-74"
                                              : Object.keys(summaryDetails)[i] === "countofhousehold"
                                                  ? "Households"
                                                  : Object.keys(summaryDetails)[i] === "seventyfiveandabove"
                                                    ? "Population age of 75 And Above"
                                                    : Object.keys(summaryDetails)[i];


        let formatValue;

        if (Object.keys(summaryDetails)[i] === "rvparksinmarket" ||
          Object.keys(summaryDetails)[i] === "totalrvparksites" ||
          Object.keys(summaryDetails)[i] === "avgpricepernight" ||
          Object.keys(summaryDetails)[i] === "rvownershipinmarket" ||
          Object.keys(summaryDetails)[i] === "avgsizeofpark"
        ) {
          formatValue = priceConversion(Object.values(summaryDetails)[i]);
        }
        else {
          formatValue = priceConversion(Object.values(summaryDetails)[i]);
        }
        let headerValue =
          (Object.keys(summaryDetails)[i] === "avgpricepernight" ||
            Object.keys(summaryDetails)[i] === "incomepercapita") && formatValue !== '-'
            ? Config.Currency + formatValue
            : Object.keys(summaryDetails)[i] === "avgsizeofpark" && formatValue !== '-'
              ? formatValue + " Acres"
              : (Object.keys(summaryDetails)[i] === "percentageofhousehold" ||
                Object.keys(summaryDetails)[i] === "avgmaleinmarket" ||
                Object.keys(summaryDetails)[i] === "avgfemaleinmarket") && formatValue !== '-'
                ? formatValue + "%"
                : formatValue;
        summary.push(
          <tr key={Object.keys}>
            <td>{tableHeader}</td>
            <td>
           {FreeUser?(
        <Link 
          component="span"
          onClick={() => props.setOpenSubscriptionDialog(true)}
      style={{ cursor: 'pointer' }}
        >
          Upgrade
        </Link>
      )
        : headerValue}
       </td>
          </tr>
        );
      }
    }
    return summary;
  };

  //price conversion
  const priceConversion = (tot) => {
    if (tot === null || tot === undefined)
      return '-';

    if (tot !== "" && tot !== null) {
      let checkDigit = tot.toString().split(".");
      let ret = "";
      let i = 0;
      if (tot.toString().indexOf(".") == -1) {
        tot = tot;
      } else {
        if (checkDigit == "00") {
          tot = checkDigit.trim();
        } else {
          if (checkDigit.length === 2) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              if (i >= checkDigit[1].length) ret += "0";
              else ret += checkDigit[1][i];
            }
            if (ret == "0.00") {
              ret = '-';
            }
          } else if (checkDigit.length === 1) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              ret += "0";
            }

            if (ret == '0') {
              ret = '-';
            }
          }
          ret = ret.toString();
          tot = ret;
        }
      }
    }
    return tot.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div>
      {props.loader ? (
        <div className="loader-wrap">
          <div className="loading"></div>
        </div>
      ) : null}

      <div className="market-title">
        <h5>
          Market Summary
          <span>
            {" "}
            {props.sliderValue
              ? `${props.sliderValue} miles radius around `
              : ""}
          </span>
        </h5>
        <div className="fav-pdf">
          {/* <DownloadOutlinedIcon /> */}
          {open ? (
            <Tooltip title="Collapse">
              <ArrowCircleUpIcon onClick={toggle} className="down-up-arrow" />
            </Tooltip>
          ) : (
            <Tooltip title="Expand">
              <ArrowCircleDown onClick={toggle} className="down-up-arrow" />
            </Tooltip>
          )}
        </div>
        {/* {props.showSummary ? (
          <Clear
            className="close-icon"
            onClick={() => props.toggleSummary(false)}
          />
        ) : null} */}
        <p className="address-section">
          {/* <FmdGoodOutlinedIcon /> */}
          {profileData && profileData.profile !== undefined && profileData.profile.streetaddress1
            ? profileData.profile.streetaddress1 + ", "
            : props.profileAdd && props.profileAdd !== null
              ? props.profileAdd
              : ""}
          {profileData && profileData.profile !== undefined && profileData.profile.streetaddress2
            ? profileData.profile.streetaddress2 + ", "
            : ""}
          {profileData && profileData.profile !== undefined && profileData.profile.city
            ? profileData.profile.city + ", "
            : ""}
          {profileData && profileData.profile !== undefined && profileData.profile.statecode
            ? profileData.profile.statecode + " "
            : ""}
          {profileData && profileData.profile !== undefined && profileData.profile.zipcode
            ? profileData.profile.zipcode
            : ""}
        </p>
        <div className="clear"></div>
      </div>

      {open ? (
        <>
          <p className="info-msg demand-market-score">
            {/* Changes for Market Score board */}
            {props.summaryData.summaryInfo && JSON.parse(localStorage.getItem('user')).usertype !== 'Free' ?
              <div className="ratio-number">
                <div className="market-score-value">
                  <div className="small-info-popover">
                    <p className="info-msg-us mb-0">*Demographic data based on U.S. Census Bureau's 2023 American Community Survey.</p>
                  </div>
                </div>
              </div>
              : null}
          </p>
          <div className="table-summary-details">
            <table>
              <tbody>
                {props.summaryData.summaryInfo && getSummaryDetails()}
                {summary.length === 0 && !props.loader ? (
                  <tr>
                    <td
                      style={{ textAlign: "center" }}
                      className="store-no-data"
                    >
                      No Data Available
                    </td>
                  </tr>) : null}
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </div>
  );
});

export default MarketSummary;
